import React, {memo, useCallback, useEffect, useRef, useState,} from "react";
import {SectorSvg} from "../../../../shared/assets/svgs/SectorSvg";
import {useTranslation} from "react-i18next";
import {useZipcodes} from "../../hooks/useZipcodes";
import {Fill, Stroke, Style, Text} from "ol/style";
import {Button, useToast} from "../../../../shared/ui";

interface Props {
  map: any;
  bound: any;
  zoom: number;
}

type TPolygonCache = {
  [key: string]: Style
};
const DARK = "#000000";
const MIN_ZOOM_VISIBLE = 13;
export const ZipcodePolygonButton = memo(({map, bound, zoom}: Props) => {
  
  const {t} = useTranslation(["shipping"]);
  const [isVisibleZipcode, setVisibleZipcode] = useState(false);
  const polygonCache = useRef<TPolygonCache>({});
  const toast = useToast();
  
  useEffect(() => {
    if (zoom < 13 && isVisibleZipcode) {
      setVisibleZipcode(false);
    }
  }, [zoom]);
  
  const zipcodeStyle = useCallback((feature: any) => {
    const zipcode = feature.get("zipcode") || "";
    if (!polygonCache.current[zipcode]) {
      polygonCache.current[zipcode] = new Style({
        stroke: new Stroke({
          color: DARK, width: 1,
        }), fill: new Fill({
          color: DARK + "10",
        }), text: new Text({
          font: "12px Calibri,sans-serif", fill: new Fill({color: "#000"}), stroke: new Stroke({
            color: "#fff", width: 2,
          }), // get the text from the feature - `this` is ol.Feature
          // and show only under certain resolution
          text: zipcode,
        }),
      })
    }
    return polygonCache.current[zipcode];
  }, []);
  
  useZipcodes(bound, map, isVisibleZipcode, zipcodeStyle);
  
  const handleZipcodeVisible = () => {
    if (!isVisibleZipcode && zoom < MIN_ZOOM_VISIBLE) {
      toast.error(t("The Zipcode layer can be visible when the zoom level exceeds")+MIN_ZOOM_VISIBLE);
      return;
    }
    setVisibleZipcode((prev) => !prev);
  };
  
  return (<Button
    variant={"primary"}
    size={"sm"}
    className={"button " + (isVisibleZipcode)}
    onClick={handleZipcodeVisible}
  >
    <SectorSvg color={(isVisibleZipcode) ? "white" : "black"} />
    {t("zipcode layer")}
  </Button>);
});
